import { render, staticRenderFns } from "./TasksPage.vue?vue&type=template&id=3c20c710&scoped=true"
import script from "./TasksPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TasksPage.vue?vue&type=style&index=0&id=3c20c710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c20c710",
  null
  
)

export default component.exports